(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-button-sticky"] && !Shopify.designMode) return;
  try {
    const target = document.querySelector('#pdp_atc');
const button = document.querySelector('.sticky-atc');

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach(entry => {
      if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
        button.classList.add('show');
      } else {
        button.classList.remove('show');
      }
    });
  },
  {
    threshold: 0,
  }
);

if (target) observer.observe(target);
  } catch(e) { console.error(e); }
})();

})();
